export default "__VITE_PUBLIC_ASSET__4031d82b__"